import { useEffect } from 'react';

interface SeoHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  articlePublishedTime?: string;
  articleModifiedTime?: string;
}

export default function SeoHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage = 'https://readdy.ai/api/search-image?query=Modern%20resource%20sharing%20platform%20with%20clean%20minimal%20design%20digital%20assets%20and%20creative%20tools%20displayed%20on%20a%20warm%20background%20professional%20website%20banner&width=1200&height=630&seq=og-default&orientation=landscape',
  articlePublishedTime,
  articleModifiedTime,
}: SeoHeadProps) {
  const fullTitle = title.includes('无码专区') ? title : `${title} - 无码专区`;
  const baseUrl = 'https://aialhku.cn';

  useEffect(() => {
    document.title = fullTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description);
    setMeta('keywords', keywords);

    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) {
      canonical.href = `${baseUrl}${canonicalUrl}`;
    } else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = `${baseUrl}${canonicalUrl}`;
      document.head.appendChild(link);
    }

    setMeta('og:title', fullTitle, true);
    setMeta('og:description', description, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', `${baseUrl}${canonicalUrl}`, true);
    setMeta('og:image', ogImage, true);
    setMeta('og:site_name', '无码专区', true);
    setMeta('og:locale', 'zh_CN', true);

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', fullTitle);
    setMeta('twitter:description', description);
    setMeta('twitter:image', ogImage);

    if (articlePublishedTime) {
      setMeta('article:published_time', articlePublishedTime, true);
    }
    if (articleModifiedTime) {
      setMeta('article:modified_time', articleModifiedTime, true);
    }
  }, [fullTitle, description, keywords, canonicalUrl, ogType, ogImage, articlePublishedTime, articleModifiedTime]);

  return null;
}